import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dayjs from 'dayjs';
import util from '@/libs/util';
import { OverDeliveryPartLoadData, OverDeliveryPartSaveData } from '@/api/OverDeliveryPart';
import ConfirmTable from './ConfirmTable.vue';
import SpareTable from './SpareTable.vue';
export default {
  name: 'OverDeliveryPartDialog',
  components: {
    ConfirmTable: ConfirmTable,
    SpareTable: SpareTable
  },
  data: function data() {
    return {
      formData: {},
      confirmTableRef: null,
      confirmTableLoading: true,
      confirmData: [],
      dialogVisible: false,
      spareTableVisible: false
    };
  },
  methods: {
    open: function open() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        VENDOR_CODE: ''
      };
      this.formData.VENDOR_CODE = params.VENDOR_CODE;
      this.dialogVisible = true;
      this.refInit();
      this.getOverDeliveryPartData(params);
    },
    close: function close() {
      this.dialogVisible = false;
    },
    handleClose: function handleClose() {
      this.$el.parentNode.removeChild(this.$el);
    },
    refInit: function refInit() {
      var _this = this;

      this.$nextTick(function () {
        _this.confirmTableRef = _this.$refs.confirmTable;
      });
    },
    confirm: function confirm() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2$confirmTableRe, insertRecords, removeRecords, updateRecords, packageData, params, res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                packageData = function _packageData(records) {
                  return records.map(function (item) {
                    var ID = item.ID,
                        ORGANIZE_ID = item.ORGANIZE_ID,
                        VENDOR_CODE = item.VENDOR_CODE,
                        PART_ID = item.PART_ID,
                        PART_NO = item.PART_NO,
                        MODIFY_MAN = item.MODIFY_MAN,
                        MODIFY_TIME = item.MODIFY_TIME;
                    return {
                      ID: ID,
                      ORGANIZE_ID: ORGANIZE_ID
                      /* : ORGANIZE_ID || util.cookies.get('ORG_ID') */
                      ,
                      VENDOR_CODE: VENDOR_CODE,
                      PART_ID: PART_ID,
                      PART_NO: PART_NO,
                      MODIFY_MAN: MODIFY_MAN,
                      MODIFY_TIME: MODIFY_TIME
                    };
                  });
                };

                _this2$confirmTableRe = _this2.confirmTableRef.getRecordset(), insertRecords = _this2$confirmTableRe.insertRecords, removeRecords = _this2$confirmTableRe.removeRecords, updateRecords = _this2$confirmTableRe.updateRecords;
                params = {
                  InsertRecords: packageData(insertRecords),
                  UpdateRecords: packageData(updateRecords),
                  RemoveRecords: packageData(removeRecords),
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _context.next = 5;
                return OverDeliveryPartSaveData(params);

              case 5:
                res = _context.sent;

                if (res.code !== 500) {
                  _this2.$message.success('提交成功');

                  _this2.close();

                  _this2.$emit('confirm-success');
                } else {
                  _this2.$message.error(res.message);
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getOverDeliveryPartData: function getOverDeliveryPartData(params) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.confirmTableLoading = true;
                _context2.next = 3;
                return OverDeliveryPartLoadData(params);

              case 3:
                res = _context2.sent;

                if (res.code === 0) {
                  _this3.confirmData = res.data;
                } else {
                  _this3.$message.error(res.message);
                }

                _this3.confirmTableLoading = false;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleCellInsertClick: function handleCellInsertClick(row) {
      var _this$confirmTableRef = this.confirmTableRef.getTableData(),
          tableData = _this$confirmTableRef.tableData;

      if (tableData.some(function (e) {
        return e.PART_ID === row.Id;
      })) {
        this.$notify({
          title: '提示',
          type: 'info',
          message: '该料号已经添加'
        });
        return;
      }

      var insertData = {
        VENDOR_CODE: this.formData.VENDOR_CODE,
        PART_ID: row.Id,
        PART_NO: row.Code,
        NAME: row.Name,
        DESCRIPTION: row.Description,
        PoUnit: row.PoUnit,
        MODIFY_MAN: this.$store.state.d2admin.user.userInfo.USER_NAME,
        MODIFY_TIME: dayjs().format('YYYY-MM-DD HH:mm:ss')
      };
      this.confirmTableRef.insert(insertData); // 高亮第一行

      this.confirmTableRef.setCurrentRow(0);
    }
  }
};